import isEqual from 'lodash-es/isEqual';
import { APISuccessAction } from 'mk2/helpers/action';
import { Entity } from 'mk2/schemas';
import { Action } from 'redux';

export interface EntitiesByID<T extends Entity = Entity> {
    [id: string]: T;
}

export interface EntitiesState {
    [entity: string]: EntitiesByID<Entity>;
}

// TODO: When and how to clear?
export function entitiesReducer(state: EntitiesState = {}, action: APISuccessAction | Action) {
    let newState = state;

    if ('response' in action && action.response && action.response.entities) {
        // We have only 2 levels
        const keys = Object.keys(action.response.entities);
        if (keys.length) {
            const newKeyState = {
                ...state,
            };

            let keyStateChanged = false;
            keys.forEach((key) => {
                const ids = Object.keys(action.response.entities[key]);
                if (ids.length) {
                    const newIdState = {
                        ...newKeyState[key],
                    };

                    let idStateChanged = false;
                    ids.forEach((id) => {
                        if (!newIdState[id] || !isEqual(newIdState[id], action.response.entities[key][id])) {
                            newIdState[id] = action.response.entities[key][id];
                            idStateChanged = true;
                        }
                    });

                    if (idStateChanged) {
                        newKeyState[key] = newIdState;
                        keyStateChanged = true;
                    }
                } else if (!(key in newKeyState)) {
                    newKeyState[key] = action.response.entities[key];
                    keyStateChanged = true;
                }
            });

            if (keyStateChanged) {
                newState = newKeyState;
            }
        }
    }

    return newState;
}

export const getEntities = (state: EntitiesState, entity: string) => (state[entity] ? state[entity] : undefined);
export const getEntity = (state: EntitiesState, entity: string, id: number | string) =>
    state[entity] && state[entity][id] ? state[entity][id] : undefined;
